import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import API_BASE_URL from '../../Config';

const EstadoResultados = () => {
    const [resultadoData, setResultadoData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fechaFin, setFechaFin] = useState(format(new Date(), 'yyyy-MM-dd'));

    const fetchResultados = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE_URL}/contabilidad/estado-resultados?fin=${fechaFin}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setResultadoData(res.data);
        } catch (error) {
            console.error("Error cargando el estado de resultados", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchResultados();
    }, []);

    const renderDetalle = (titulo, items, total, typeClass) => (
        <div className="mb-4">
            <h5 className={`border-bottom pb-2 ${typeClass}`}>{titulo}</h5>
            <table className="table table-sm table-borderless">
                <tbody>
                    {items && items.length > 0 ? (
                        items.map((item, idx) => (
                            <tr key={idx}>
                                <td width="15%" className="text-muted">{item.codigoIncoop}</td>
                                <td width="55%">{item.nombreCuenta}</td>
                                <td width="30%" className="text-right">{new Intl.NumberFormat('es-PY').format(item.saldo)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr><td colSpan="3" className="text-center text-muted">No hay registros</td></tr>
                    )}
                </tbody>
                <tfoot>
                    <tr className="border-top">
                        <td colSpan="2" className="text-right font-weight-bold">Total {titulo}</td>
                        <td className={`text-right font-weight-bold ${typeClass}`}>{new Intl.NumberFormat('es-PY').format(total || 0)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );

    return (
        <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex justify-content-between align-items-center">
                <h3 className="mb-0 text-gray-800 font-weight-bold">Estado de Resultados</h3>
                <div className="d-flex align-items-center gap-2">
                    <div className="input-group input-group-sm shadow-sm" style={{ width: '220px' }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white"><i className="fas fa-calendar-alt text-primary"></i></span>
                        </div>
                        <input 
                            type="date" 
                            value={fechaFin} 
                            onChange={e => setFechaFin(e.target.value)} 
                            className="form-control" 
                        />
                    </div>
                    <button className="btn btn-primary btn-sm px-3 shadow-sm" onClick={fetchResultados} disabled={loading}>
                        <i className="fas fa-sync-alt mr-2"></i> Generar
                    </button>
                </div>
            </div>
            
            <div className="card-body bg-gray-50">
                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status"></div>
                        <p className="mt-3 text-muted">Consolidando ingresos y egresos...</p>
                    </div>
                ) : resultadoData ? (
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="card border-0 shadow-lg" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                <div className="card-body p-5">
                                    <div className="text-center mb-5 border-bottom pb-4">
                                        <h2 className="font-weight-bold text-gray-900 mb-1">COOPERATIVA MULTIACTIVA</h2>
                                        <h4 className="text-primary font-weight-light mb-3">ESTADO DE RESULTADOS INTEGRALES</h4>
                                        <div className="badge badge-soft-primary px-3 py-2" style={{ backgroundColor: '#eff6ff', color: '#1d4ed8' }}>
                                            <i className="fas fa-history mr-2"></i> PERIODO ACUMULADO AL: {resultadoData.fechaHasta}
                                        </div>
                                    </div>

                                    {/* Sección de Ingresos */}
                                    <div className="mb-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom-2 border-success pb-2">
                                            <h5 className="mb-0 text-success font-weight-bold uppercase tracking-wider">I. INGRESOS OPERATIVOS</h5>
                                            <i className="fas fa-arrow-trend-up text-success h5 mb-0"></i>
                                        </div>
                                        <table className="table table-sm table-hover table-borderless mb-0">
                                            <tbody>
                                                {resultadoData.ingresos && resultadoData.ingresos.length > 0 ? (
                                                    resultadoData.ingresos.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td width="20%" className="text-muted font-mono" style={{ fontSize: '0.8rem' }}>{item.codigoIncoop}</td>
                                                            <td width="55%" className="text-gray-700">{item.nombreCuenta}</td>
                                                            <td width="25%" className="text-right font-weight-bold font-mono">{new Intl.NumberFormat('es-PY').format(item.saldo)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr><td colSpan="3" className="text-center py-3 text-muted italic small">No se registraron ingresos en el periodo</td></tr>
                                                )}
                                            </tbody>
                                            <tfoot className="border-top-2">
                                                <tr className="bg-success-soft" style={{ backgroundColor: '#f0fdf4' }}>
                                                    <td colSpan="2" className="text-right py-2 pr-4 font-weight-bold">SUBTOTAL INGRESOS:</td>
                                                    <td className="text-right py-2 px-3 font-weight-bold text-success h5 mb-0">{new Intl.NumberFormat('es-PY').format(resultadoData.totalIngresos || 0)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    
                                    {/* Sección de Egresos */}
                                    <div className="mb-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom-2 border-danger pb-2">
                                            <h5 className="mb-0 text-danger font-weight-bold uppercase tracking-wider">II. EGRESOS Y GASTOS</h5>
                                            <i className="fas fa-arrow-trend-down text-danger h5 mb-0"></i>
                                        </div>
                                        <table className="table table-sm table-hover table-borderless mb-0">
                                            <tbody>
                                                {resultadoData.egresos && resultadoData.egresos.length > 0 ? (
                                                    resultadoData.egresos.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td width="20%" className="text-muted font-mono" style={{ fontSize: '0.8rem' }}>{item.codigoIncoop}</td>
                                                            <td width="55%" className="text-gray-700">{item.nombreCuenta}</td>
                                                            <td width="25%" className="text-right font-weight-bold font-mono">({new Intl.NumberFormat('es-PY').format(item.saldo)})</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr><td colSpan="3" className="text-center py-3 text-muted italic small">No se registraron egresos en el periodo</td></tr>
                                                )}
                                            </tbody>
                                            <tfoot className="border-top-2">
                                                <tr className="bg-danger-soft" style={{ backgroundColor: '#fef2f2' }}>
                                                    <td colSpan="2" className="text-right py-2 pr-4 font-weight-bold">SUBTOTAL EGRESOS:</td>
                                                    <td className="text-right py-2 px-3 font-weight-bold text-danger h5 mb-0">{new Intl.NumberFormat('es-PY').format(resultadoData.totalEgresos || 0)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    
                                    {/* Resultado Final */}
                                    <div className={`p-4 rounded shadow-sm border ${resultadoData.utilidadNeta >= 0 ? 'bg-success text-white border-success' : 'bg-danger text-white border-danger'} animate__animated animate__fadeInUp`}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h4 className="mb-1 font-weight-bold">
                                                    {resultadoData.utilidadNeta >= 0 ? 'EXCEDENTE (UTILIDAD) DEL EJERCICIO' : 'PÉRDIDA DEL EJERCICIO'}
                                                </h4>
                                                <span className="small text-white-50">Cifras expresadas en Guaraníes (PYG)</span>
                                            </div>
                                            <div className="text-right">
                                                <h2 className="mb-0 font-weight-bold" style={{ fontSize: '2.5rem' }}>
                                                    {new Intl.NumberFormat('es-PY').format(resultadoData.utilidadNeta)}
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-center p-5 text-muted">No se pudo recuperar la información del estado de resultados.</div>
                )}
            </div>
        </div>
    );
};

export default EstadoResultados;
